import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function PricingPage() {
  const { t } = useLanguage();

  const pricingData = [
    {
      category: 'cat_alterations',
      groups: [
        {
          title: 'sub_shirts',
          items: [
            { key: 'item_taper_shirt', price: '€0,00' },
            { key: 'item_shorten_sleeve_cuff', price: '€0,00' },
            { key: 'item_shorten_sleeve_shoulder', price: '€0,00' },
            { key: 'item_shorten_shirt', price: '€0,00' },
            { key: 'item_collar', price: '€0,00' },
            { key: 'item_narrow_sleeve', price: '€0,00' },
          ]
        },
        {
          title: 'sub_trousers',
          items: [
            { key: 'item_hem_length', price: '€0,00' },
            { key: 'item_waist_length', price: '€0,00' },
            { key: 'item_waist_trouser', price: '€0,00' },
            { key: 'item_waist_denim', price: '€0,00' },
            { key: 'item_waist_suit', price: '€0,00' },
            { key: 'item_taper_legs', price: '€0,00' },
          ]
        },
        {
          title: 'sub_dresses',
          items: [
            { key: 'item_dress_hem', price: '€0,00' },
            { key: 'item_dress_waist', price: '€0,00' },
            { key: 'item_dress_straps', price: '€0,00' },
            { key: 'item_dress_neckline', price: '€0,00' },
            { key: 'item_dress_taper', price: '€0,00' },
          ]
        },
        {
          title: 'sub_jackets',
          items: [
            { key: 'item_jacket_length', price: '€0,00' },
            { key: 'item_jacket_sleeve', price: '€0,00' },
            { key: 'item_jacket_shoulder', price: '€0,00' },
            { key: 'item_jacket_taper', price: '€0,00' },
          ]
        },
        {
          title: 'sub_bridal',
          items: [
            { key: 'item_bride_length', price: '€0,00' },
            { key: 'item_bride_bodice', price: '€0,00' },
            { key: 'item_bride_taper', price: '€0,00' },
            { key: 'item_bride_straps', price: '€0,00' },
          ]
        },
        {
          title: 'sub_evening',
          items: [
            { key: 'item_evening_length', price: '€0,00' },
            { key: 'item_evening_bodice', price: '€0,00' },
            { key: 'item_evening_taper', price: '€0,00' },
            { key: 'item_evening_straps', price: '€0,00' },
          ]
        },
      ]
    },
    {
      category: 'cat_repairs',
      groups: [
        {
          title: 'sub_general',
          items: [
            { key: 'item_repair_seam', price: '€0,00' },
            { key: 'item_button', price: '€0,00' },
            { key: 'item_zipper', price: '€0,00' },
            { key: 'item_tear', price: '€0,00' },
            { key: 'item_repair_lining', price: '€0,00' },
            { key: 'item_replace_lining', price: '€0,00' },
          ]
        },
        {
          title: 'sub_knitwear',
          items: [
            { key: 'item_debobble', price: '€0,00' },
            { key: 'item_darn_visible', price: '€0,00' },
            { key: 'item_darn_invisible', price: '€0,00' },
          ]
        },
        {
          title: 'sub_outerwear',
          items: [
            { key: 'item_outer_tear', price: '€0,00' },
            { key: 'item_outer_zipper', price: '€0,00' },
            { key: 'item_outer_lining', price: '€0,00' },
          ]
        },
      ]
    },
    {
      category: 'cat_bespoke',
      groups: [
        {
          title: '',
          items: [
            { key: 'item_hand_embroidery', price: '€0,00' },
            { key: 'item_machine_embroidery', price: '€0,00' },
            { key: 'item_embellishment', price: '€0,00' },
            { key: 'item_dyeing', price: '€0,00' },
          ]
        },
        {
          title: '',
          items: [
            { key: 'item_denim_paint', price: t('price_on_request') },
            { key: 'item_upcycling', price: t('price_on_request') },
            { key: 'item_made_measure', price: t('price_on_request') },
            { key: 'item_fur', price: t('price_on_request') },
          ]
        },
      ]
    },
    {
      category: 'cat_leather',
      groups: [
        {
          title: '',
          items: [
            { key: 'item_bag_zipper', price: '€0,00' },
            { key: 'item_bag_colour', price: '€0,00' },
            { key: 'item_bag_touchup', price: '€0,00' },
            { key: 'item_bag_change_colour', price: '€0,00' },
            { key: 'item_bag_lining', price: '€0,00' },
          ]
        },
      ]
    },
  ];

  return (
    <>
      <section className="pricing-header-section">
        <div className="container">
          <h1>{t('pricing_title')}</h1>
          <p>{t('pricing_intro')}</p>
        </div>
      </section>

      <section className="pricing-content">
        <div className="container">
          {pricingData.map((cat, i) => (
            <div className="pricing-category" key={i}>
              <h2>{t(cat.category)}</h2>
              <div className="pricing-grid-2">
                {cat.groups.map((group, j) => (
                  <div className="pricing-group" key={j}>
                    {group.title && <h3>{t(group.title)}</h3>}
                    {group.items.map((item, k) => (
                      <div className="pricing-row" key={k}>
                        <span>{t(item.key)}</span>
                        <span>{item.price}</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="pricing-cta">
            <p>{t('pricing_cta')}</p>
            <a href="https://wa.me/34611228437" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              {t('btn_quote')}
            </a>
          </div>
        </div>
      </section>

      <style>{`
        .pricing-header-section {
          padding: 7rem 2rem 2rem;
          background: #ffffff;
          text-align: center;
          border-bottom: 1px solid #e0e0e0;
        }
        .pricing-header-section h1 {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 2.2rem;
          color: #121312;
          margin-bottom: 0.8rem;
          font-weight: 700;
        }
        .pricing-header-section p {
          font-family: 'Nanum Gothic', sans-serif;
          color: #6c757d;
          font-size: 0.95rem;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.7;
        }
        .pricing-content {
          padding: 2rem;
        }
        .pricing-category {
          margin-bottom: 2rem;
        }
        .pricing-category h2 {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 1.3rem;
          color: #121312;
          margin-bottom: 1rem;
          padding-bottom: 0.5rem;
          border-bottom: 2px solid #3b80cf;
          font-weight: 700;
        }
        .pricing-grid-2 {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
        }
        .pricing-group {
          background: #ffffff;
          padding: 1rem 1.2rem;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.06);
        }
        .pricing-group h3 {
          font-family: 'Nanum Gothic', sans-serif;
          font-size: 0.65rem;
          font-weight: 700;
          color: #6c757d;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin-bottom: 0.6rem;
          padding-bottom: 0.4rem;
          border-bottom: 1px solid #e0e0e0;
        }
        .pricing-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.5rem 0;
          border-bottom: 1px solid #f5f5f5;
          font-size: 0.85rem;
        }
        .pricing-row:last-child {
          border-bottom: none;
        }
        .pricing-row span:first-child {
          color: #333;
          font-weight: 400;
          padding-right: 1rem;
          line-height: 1.3;
        }
        .pricing-row span:last-child {
          color: #121312;
          font-weight: 600;
          font-family: 'Nanum Gothic', sans-serif;
          min-width: 70px;
          text-align: right;
          font-size: 0.8rem;
          white-space: nowrap;
        }
        .pricing-cta {
          text-align: center;
          padding: 2rem;
          margin-top: 1.5rem;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        }
        .pricing-cta p {
          font-family: 'Playfair Display', Georgia, serif;
          font-size: 1.2rem;
          color: #121312;
          margin-bottom: 1rem;
        }
        .btn {
          padding: 0.8rem 2rem;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          cursor: pointer;
          border: none;
          font-size: 0.95rem;
        }
        .btn-primary {
          background: #3b80cf;
          color: #ffffff;
          box-shadow: 0 4px 15px rgba(192, 57, 43, 0.4);
        }
        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(192, 57, 43, 0.6);
        }
        .container {
          max-width: 1000px;
          margin: 0 auto;
        }
        @media (max-width: 768px) {
          .pricing-header-section h1 { font-size: 1.6rem; }
          .pricing-grid-2 { grid-template-columns: 1fr; }
          .pricing-row { padding: 0.45rem 0; }
        }
      `}</style>
    </>
  );
}
